//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
// import { isProductType } from '@motionelements/core/src/services/catalog.service.js';
import elementMixin from '@motionelements/core/src/components/mixins/element.mixin.js';

export default {
  name: 'product-card-audio-actions',
  components: {
    ButtonFavorite: () => import('./actions/ProductButtonFavorite.vue'),
    ButtonSimilar: () => import('./actions/ProductButtonSimilar.vue'),
    ButtonDownloadSample: () => import('./actions/ProductButtonDownloadSample.vue'),
    ButtonProductPage: () => import('./actions/ProductButtonProductPage.vue'),
  },
  mixins: [elementMixin],
  props: {
    element: Object,
    showFavorite: {
      type: Boolean,
      default: true,
    },
    showSimilar: {
      type: Boolean,
      default: false,
    },
    showDownloadSample: {
      type: Boolean,
      default: false,
    },
    linkUrl: String,
  },
  computed: {
    ...mapState({
      favoritesAddedToday: state => state.favorites.addedToday,
    }),
    favoritesAddedTodayIds() {
      return this.favoritesAddedToday.map(x => x.id);
    },
    mediaType() {
      return _.get(this.element, 'mediaType');
    },
    isAudio() {
      return true;
      // return isProductType('audio', this.mediaType);
    },
    // hasSample() {
    //   if (!this.element) {
    //     return false;
    //   }
    //   // if no preview
    //   if (!_.size(this.element.previews)) {
    //     return false;
    //   }
    //   return true;
    //   // return isProductType('audio', this.mediaType);
    // },
    isSimilaritySearchEnabled() {
      return _.get(this.element, 'similarity');
    },
  },
};
